import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
    OneLineDiagramState,
    MappedNode,
    DiagramItem,
} from './types';
import { LookupItem } from "common/types";

const initialState: OneLineDiagramState = {
    currentTab: 1,

    scenarios: [],
    selectedScenario: null,

    areas: [],
    selectedAreas: [],

    unitTypes: [],
    selectedUnitTypes: [],

    nodes: [],
    selectedNode: "",

    selectedRedrawNode: "", //Used when user dbclick on node to redraw

    selectedType: "",

    steps: 1,

    selectedDiagramItem: null,

    fromNodes: [],
    selectedFromNode: null,
    toNodes: [],
    selectedToNode: null,
};

const oneLineDiagramSlice = createSlice({
    name: "oneLineDiagram",
    initialState,
    reducers: {
        setScenarios(state, action: PayloadAction<LookupItem[]>) {
            state.scenarios = action.payload;
        },
        setAreas(state, action: PayloadAction<string[]>) {
            state.areas = action.payload;
        },
        setUnitTypes(state, action: PayloadAction<string[]>) {
            state.unitTypes = action.payload;
        },
        setNodes(state, action: PayloadAction<{ field: 'nodes' | 'fromNodes' | 'toNodes'; data: MappedNode[] }>) {
            const { field, data } = action.payload;

            switch (field) {
                case 'nodes':
                    state.nodes = data;
                    break;
                case 'fromNodes':
                    state.fromNodes = data;
                    break;
                case 'toNodes':
                    state.toNodes = data;
                    break;
                default:
                    break;
            }
        },
        setSelectedScenario(state, action: PayloadAction<number>) {
            state.selectedScenario = action.payload;
        },
        setSelectedNode(state, action: PayloadAction<string>) {
            state.selectedNode = action.payload;
        },
        setSelectedFromNode(state, action: PayloadAction<MappedNode>) {
            state.selectedFromNode = action.payload;
        },
        setSelectedToNode(state, action: PayloadAction<MappedNode>) {
            state.selectedToNode = action.payload;
        },
        setSteps(state, action: PayloadAction<number>) {
            state.steps = action.payload;
        },
        setSelectedType(state, action: PayloadAction<string>) {
            state.selectedType = action.payload;
        },
        setSelectedRedrawNode(state, action: PayloadAction<string>) {
            state.selectedRedrawNode = action.payload;
        },
        setSelectedAreas(state, action: PayloadAction<string[]>) {
            state.selectedAreas = action.payload;
        },
        setSelectedUnitTypes(state, action: PayloadAction<string[]>) {
            state.selectedUnitTypes = action.payload;
        },
        setSelectedDiagItem(state, action: PayloadAction<DiagramItem | null>) {
            state.selectedDiagramItem = action.payload;
        },
        setTab(state, action: PayloadAction<number>) {
            state.currentTab = action.payload;
        },
        reset(state) {
            state = { ...initialState };
        },
    },
});

export const actions = oneLineDiagramSlice.actions;
export default oneLineDiagramSlice.reducer;
